import { fadeInAnimationLong, fadeInAnimationShort, styles } from 'consts';
import styled from 'styled-components';

const {
  animationLong,
  animationShort,
  white,
  primaryRed,
  primaryBlack,
  failureScreenButtonGradient,
  fontMBank,
} = styles;

export const FailureScreenButtonWrapper = styled.div<{ isRecoveryPaymentEnabled?: boolean }>`
  @media (min-width: 992px) {
    ${props =>
      props.isRecoveryPaymentEnabled &&
      ` display: flex;
        justify-content: center;
  `}
  }
  .failure-screen__recovery-payment-button {
    @media (max-width: 992px) {
      width: 100%;
      display: block;
    }
  }
`;

export const FailureScreenContainer = styled.div<{ isLoading: boolean; height: number }>`
  border-radius: 0.5rem;
  background: ${white};
  text-align: center;
  color: ${white};
  padding: 3.3125rem;

  ${props =>
    props.isLoading &&
    ` padding: 0;
      height: ${props.height}px;
  `}
  .failure-screen__recovery-payment-button {
    display: inline-block;

    @media (max-width: 992px) {
      width: 100%;
      display: block;
    }
  }
`;

export const FailureScreenWrapper = styled.div`
  ${fadeInAnimationShort};
  animation: ${animationShort};

  @media (max-width: 992px) {
    max-width: 14.125rem;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const FailureScreenTitle = styled.div`
  font-size: 1.6rem;
  margin: 0 auto;
  line-height: 2.5rem;
  color: ${primaryRed};
  font-weight: bold;
  margin-bottom: 1rem;
`;

export const FailureScreenIcon = styled.div`
  ${fadeInAnimationLong};
  animation: ${animationLong};
  img {
    width: 12.5rem;
    height: 9.375rem;
  }
  margin-bottom: 0.5rem;
`;

export const FailureScreenMessage1 = styled.div`
  font-size: 1rem;
  line-height: 1.5;
  font-weight: bold;
  color: ${primaryBlack};
  margin-bottom: 1.25rem;
`;

export const FailureScreenMessage2 = styled(FailureScreenMessage1)`
  font-weight: normal;
  margin-bottom: 2.25rem;
`;

export const FailureScreenBackToShopButton = styled.button<{ isRecoveryPaymentEnabled?: boolean }>`
  position: relative;
  white-space: nowrap;
  border-radius: 0.6875rem;
  margin-left: 2rem;
  background-image: ${failureScreenButtonGradient};
  border-radius: 0.6875rem;
  color: ${white};
  padding: 0.625rem 4.5rem;
  font-size: 1rem;
  font-weight: 500;
  text-transform: uppercase;
  font-family: ${fontMBank};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  ${props =>
    props.isRecoveryPaymentEnabled &&
    ` padding: 0;
      width: 40%;
      height: 2.5rem;
      color: #DA1600;
      background-image: none;
      background-color: #FFFFFF;
      white-space: normal;
      margin: 1rem 0 0 0;
  `}

  @media (max-width: 992px) {
    width: 100%;
    margin: 0.625rem 0;
    white-space: normal;
    padding: 0.625rem 0.5rem;
  }
`;
